
import TopCategoryTile from "./TopCategoryTile";

export default {
  components: { TopCategoryTile },

  props: { fields: { type: Array, default: () => {} } },

  data: () => ({ swiper: null }),

  computed: {
    swiperOptions() {
      return {
        slidesPerGroup: 1,
        slidesPerView: "auto",
        loop: false,
        loopFillGroupWithBlank: false,
      };
    },
  },

  async mounted() {
    await this.$swiper.init(".swiper.m-top-category", this.swiperOptions);
  },

  destroyed() {
    this.$swiper.destroy(".swiper.m-top-category");
  },
};
